import { useAtomValue } from "jotai";
import { redirectModalVisibleOrLoadingAtom } from "./redirectModalAtoms";

export const useRedirectModalState = () => {
  const redirectModalIsVisibleOrLoading = useAtomValue(
    redirectModalVisibleOrLoadingAtom,
  );

  return {
    redirectModalIsVisibleOrLoading,
  };
};
